





























































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import api, { apiSandbox } from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import FileIcon from 'mdi-vue/File';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import PaymentMethod from '@/components/ModalContent/PaymentMethod.vue';
import Step2 from './Step2.vue';
import Step3 from './Step3.vue';
import Step4 from './Step4.vue';
import Step5 from './Step5.vue';
import Step6 from './Step6.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    SearchIcon,
    FileIcon,
    SearchRow,
    SearchField,
    Select,
    Modal,
    FormInput,
    PaymentMethod,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    ValidationObserver,
  },
  computed: mapState(['user']),
})
export default class Integration extends Vue {
  activeStep = 1;
  user!: {
    user: User;
  };

  active = false;
  merchantCode = '';
  showModal = false;

  isActiveStep(step: number) {
    return step <= this.activeStep;
  }

  setStep(step: number) {
    // if (step === this.activeStep + 1) {
    this.activeStep = step;
    // }
  }

  mounted() {
    this.checkChannel();
    this.cekActive();
  }

  async checkChannel() {
    try {
      const { data } = await api.get('/merchant/service');
      const keys = Object.keys(data);
      if (keys.length === 0) {
        this.showModal = true;
      }
    } catch (err) {
      console.error(err);
      this.showModal = true;
    }
  }

  async cekActive() {
    const { data, status } = await apiSandbox.get('/paymentChannel');

    // eslint-disable-next-line no-useless-catch
    try {
      if (status === 200) {
        data.forEach((e: any) => {
          if (e === '2002') {
            this.active = true;
          }
        });
      }
    } catch (err) {
      throw err;
    }
  }
}
